<template lang="pug">
	section.section.editProfileContainer

		//- Change Password via Auth0 (Auth0 will send a reset password email)
		button.button(v-if="!authServerMessage", @click="changePassword") Change Password
		br
		p {{ authServerMessage }}
		p.spacer
		hr

		.columns
			//- Turn on notifications when a new measurement is taken (allow:notify needed)
			.column.is-one-third(v-if="permissions.indexOf('allow:notify') > -1")
				.box
					h1.title Notification Settings
					b-field(label="Department")
						b-select(v-model="selectedOrg", :disabled="userOrgs.length < 2")
							option(v-for="org in userOrgs", :key="org", :value="org") {{ org }}
					br
					.buttons
						button.button(@click="startEmailNotifications") Subscribe to Email Notifications
						button.button(@click="stopEmailNotifications") Unsubscribe from Email Notifications

			//- Calibrate sensor (calibrate:sensor needed)
			.column.is-one-third(v-if="permissions.indexOf('calibrate:sensor') > -1")
				.box
					h1.title Thermometer Settings
					b-button(@click="calibratingSensor = true") Calibrate Thermometer
					//- Modal Container for CalibrateSensor component
					b-modal(:active.sync="calibratingSensor", has-modal-card, trap-focus)
						CalibrateSensor
		p.spacer

		//- Technical Support screen (full:credits needed)
		template(v-if="permissions.indexOf('full:credits') > -1")
			//- p Please contact Brandon Yee at brandon.yee@yale.edu for support or technical assistance.
</template>

<style lang="scss" scoped>
	//
</style>

<script>
	import { mapState, mapGetters } from "vuex";
	import apiService from "@/services/apiService.js";
	export default {
		components: {
			CalibrateSensor: () => import("@/components/CalibrateSensor.vue")
		},
		data() {
			return {
				authServerMessage: "", // the message returned from the Auth0 API call
				selectedOrg: null, // which organization to (un)subscribe notifications (from)to
				calibratingSensor: false // show modal or not that contains CalibrateSensor component
			};
		},
		computed: {
			...mapState(["user", "permissions"]),
			...mapGetters(["userOrgs"])
		},
		methods: {
			changePassword() {
				apiService
					.changePassword(this.$auth.user.email, "Username-Password-Authentication")
					.then((res) => {
						this.authServerMessage = res.data; // show Auth0's message to the user
					})
					.catch((err) => {
						console.log(err);
					});
			},
			// Subscribe to email notifications
			startEmailNotifications() {
				apiService
					.startEmailNotifications({ org: this.selectedOrg, email: this.user.email })
					.then((res) => {
						this.$buefy.snackbar.open({
							duration: 3000,
							message: res.data,
							type: "is-success",
							position: "is-top-right",
							queue: false
						});
					})
					.catch((err) => {
						console.log(err);
						this.$buefy.snackbar.open({
							duration: 3000,
							message: "Unknown error occured.",
							type: "is-danger",
							position: "is-top-right",
							queue: false
						});
					});
			},
			// Unsubscribe to email notifications
			stopEmailNotifications() {
				apiService
					.stopEmailNotifications({ org: this.selectedOrg, email: this.user.email })
					.then((res) => {
						this.$buefy.snackbar.open({
							duration: 3000,
							message: res.data,
							type: "is-success",
							position: "is-top-right",
							queue: false
						});
					})
					.catch((err) => {
						console.log(err);
						this.$buefy.snackbar.open({
							duration: 3000,
							message: "Unknown error occured.",
							type: "is-danger",
							position: "is-top-right",
							queue: false
						});
					});
			}
		},
		mounted() {
			// Select default organization in dropdown
			this.selectedOrg = this.userOrgs[0];
		}
	};
</script>
